module.exports = __webpack_public_path__ + "static/media/banco.7921deb5.svg";